export default __webpack_public_path__ + "images/530c255d3126cbb474f248385d64abe5-san_francisco_desktop.webp";